import ApplicationSelector from "@/Components/Selectors/ApplicationSelector";
import { useNavigate } from "react-router-dom";
import DateSelector from "../../../../Components/DateSelector";
import { useActions } from "../../../../Hooks/redux/useActions";
import { useAppSelector } from "../../../../Hooks/redux/useAppSelector";
import BasicButton from "../../../../UI/BasicButton";
import PeriodStatistic from "../../components/PeriodStatistic";
import { OrdersFilterBlock } from "./styled";

const OrdersFiltersModule = () => {
  const navigate = useNavigate();

  const {
    selectedAppId = 0,
    dateStart,
    dateStop,
  } = useAppSelector((state) => state.myOrdersFiltersSlice);

  const { setOrdersSelectedApp, setOrdersDateStart, setOrdersDateStop } =
    useActions();

  const handleNavigateNewCampaign = () => {
    navigate("/create_campaign/create");
  };

  const handleSetSelectedApp = (appId: number) => {
    setOrdersSelectedApp(appId);
  };

  return (
    <OrdersFilterBlock>
      <BasicButton
        onClick={handleNavigateNewCampaign}
        size="md"
        text="Add campaign"
        variant="blue"
      />
      <ApplicationSelector
        size="md"
        placeholder="Select app"
        value={selectedAppId}
        onChange={handleSetSelectedApp}
        disabled={false}
      />
      <DateSelector
        handleGetDateStart={setOrdersDateStart}
        handleGetDateStop={setOrdersDateStop}
        dateStart={dateStart}
        dateStop={dateStop}
      />
      <PeriodStatistic />
    </OrdersFilterBlock>
  );
};

export default OrdersFiltersModule;
